import { useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import { getBFY, getStoreLocation } from '../../APIs/functions'
import ProductCarousel from '../../Components/Carousel'
import { useSearchParams } from 'react-router-dom'
import { handleHotlinkClick } from '../../Utils/Gtag'
import { provisionsStores } from '../../Utils/constants'

const BFYCarousel = () => {
  const queries = {
    retry: 1,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    cacheTime: 325000,
    staleTime: 300000
  };

  const bfyRef = useRef();
  const [searchParams] = useSearchParams();

  let upcCode = searchParams.get("upcCode");
  const client = searchParams.get("client");
  const domain = searchParams.get("domain");

  const [retryCount, setRetryCount] = useState(0);

  // First query: fetch store locations if client matches
  const {
    data: allLocations,
    isLoading: locationLoading,
    isError: locationError
  } = useQuery(
    ['allLocations', client],
    () => getStoreLocation("provisions"),
    {
      ...queries,
      enabled: provisionsStores.includes(client)
    }
  );

  // Determine location param only if first API was called
  const locationParam =
    provisionsStores.includes(client) && allLocations
      ? allLocations.find(loc => loc.filter_name === client)
      : undefined;

  // Second query: fetch BFY products
  const {
    data,
    isLoading,
    isError,
    refetch
  } = useQuery(
    ['BFYproducts', upcCode, client, locationParam],
    () => getBFY({ upcCode, client, location: locationParam?.client_location_id }),
    {
      ...queries,
      enabled: !!upcCode // only run when we have a UPC
    }
  );

  const products =
    !isLoading && !isError
      ? Array.isArray(data)
        ? data
        : data?.header !== "Members also looked at" && data?.productRecommendedData
      : [];

  useEffect(() => {
    if (!isLoading) {
      const shouldRetry =
        isError ||
        !data ||
        !products ||
        data?.status === 404 ||
        data?.status === 500 ||
        products.length === 0;

      if (shouldRetry) {
        if (upcCode.length !== 11 && upcCode.length === 12 && upcCode.startsWith('0')) {
          if (retryCount === 0) {
            upcCode = upcCode.substring(1);
            refetch().then(() => setRetryCount(retryCount + 1));
          } else {
            notifyBFYUnavailable(upcCode);
          }
        } else if (upcCode.length === 11) {
          if (retryCount === 0) {
            upcCode = "0" + upcCode;
            refetch().then(() => setRetryCount(retryCount + 1));
          } else {
            notifyBFYUnavailable(upcCode);
          }
        } else {
          notifyBFYUnavailable(upcCode);
        }
      }
    }
  }, [data, isLoading, isError, retryCount]);

  const notifyBFYUnavailable = (code) => {
    console.log(`BFY not available for UPC: ${code}`);
    window.parent.postMessage({ type: "bfy", message: "BFY not available" }, "*");
    if (bfyRef.current) {
      bfyRef.current.remove();
    }
  };

  return (
    <>
      {!isLoading && !isError && products ? (
        <div className='container'>
          {products.length > 0 && (
            <div className='row h-100 p-3'>
              <h4 className='text-center mb-4'>
                <span>Better-for-You Alternatives</span>
              </h4>
              <ProductCarousel products={products} client={client} domain={domain} />
              <a
                onClick={handleHotlinkClick}
                href="https://about.greenchoicenow.com/"
                rel="noreferrer"
                target="_blank"
                className='branding mt-3'
              >
                Powered by GreenChoice
                <img src="./images/gclogo.svg" alt="Greenchoice" />
              </a>
            </div>
          )}
        </div>
      ) : null}
    </>
  );
};

export default BFYCarousel;
